<template>
  <div id="app">
    <!-- Header Global -->
    <header class="app-header">
      <div class="header-container">
        <a href="/orders" class="logo-link">
          <img 
            src="https://www.yogurshop.com/static/version1766058534/frontend/Sm/yogurshop/es_ES/images/yogurshop.png" 
            alt="YogurShop" 
            class="logo"
          />
        </a>
        <nav class="main-nav">
          <a href="/orders" class="nav-link">
            <i class="fas fa-box"></i> Pedidos
          </a>
          <a href="/manifests" class="nav-link">
            <i class="fas fa-file-alt"></i> Manifiestos
          </a>
        </nav>
      </div>
    </header>
    <!-- Contenido -->
    <main class="app-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Reset y base */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: #f5f7fa;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

#app {
  min-height: 100vh;
}

/* Header */
.app-header {
  background: linear-gradient(135deg, #e42584 0%, #c41e6a 100%);
  box-shadow: 0 2px 10px rgba(228, 37, 132, 0.3);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo {
  height: 45px;
  width: auto;
  filter: brightness(0) invert(1);
  transition: transform 0.2s ease;
}

.logo:hover {
  transform: scale(1.05);
}

/* Navegación */
.main-nav {
  display: flex;
  gap: 10px;
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.nav-link i {
  font-size: 14px;
}

/* Contenido principal */
.app-content {
  padding-top: 20px;
}
</style>
